import {EmojiButton} from "@joeattardi/emoji-button"

const emojiButton = new EmojiButton({
    position: "top-start"
})

export default emojiButton
